import { useContext } from 'react';
import { FormContext } from './Form';

export const useForm = () => {
  return useContext(FormContext);
};
